<template>
  <div>
    <div class="head">
      <div class="headLogo" @click="$router.push('/')">
        <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
      </div>
      <div class="ut">Mfo Eckz, Too</div>
    </div>
    <!-- 中间内容 -->
    <div class="minu">
      <div>
        <div class="minu_title">Контактная информация знакомого </div>
        <el-form :inline="false" :model="formInline" ref="formInline" :rules="rules">
          <!-- 关系1 -->
          <div class="from_title">Контакт 1</div>
          <!-- 姓名 -->
          <el-form-item prop="relatives_1_name">
            <el-input v-model="formInline.relatives_1_name" style="width: 2.8rem;" placeholder="ФИО знакомого"></el-input>
          </el-form-item>
          <!-- 关系 -->
          <el-form-item prop="kinship_1">
            <el-select v-model="formInline.kinship_1" placeholder="Кем вам является этот человек?" class="demo-form-inline">
              <el-option v-for="(item,index) in kinship_1" :value="index" :label="item" :key="index" class="demo-form-inlineoptio"></el-option>
            </el-select>
          </el-form-item>
          <!-- 电话 -->
          <el-form-item prop="relatives_1_phone" style="margin-bottom: 0.21rem;">
            <el-input v-model="formInline.relatives_1_phone" style="width: 2.8rem;" placeholder="Контактный номер знакомого" type="number" @input="limitPhoneNum($event,'relatives_1_phone')">
              <template slot="prepend">+7</template>
            </el-input>
          </el-form-item>
          <!-- 关系2 -->
            <div class="from_title">Контакт 2</div>
            <!-- 姓2 -->
            <el-form-item prop="relatives_2_name">
              <el-input v-model="formInline.relatives_2_name" style="width: 2.8rem;" placeholder="ФИО знакомого"></el-input>
            </el-form-item>
            <!-- 关系2 -->
            <el-form-item prop="kinship_2">
              <el-select v-model="formInline.kinship_2" placeholder="Кем вам является этот человек?" class="demo-form-inline">
                <el-option v-for="(item,index) in kinship_2" :value="index" :label="item" :key="index" class="demo-form-inlineoptio"></el-option>
              </el-select>
            </el-form-item>
            <!-- 电话2 -->
            <el-form-item prop="relatives_2_phone" style="margin-bottom: 0.21rem;">
              <el-input v-model="formInline.relatives_2_phone" style="width: 2.8rem;" placeholder="Контактный номер знакомого" type="number" @input="limitPhoneNum($event,'relatives_2_phone')">
                <template slot="prepend">+7</template>
              </el-input>
            </el-form-item>
        </el-form>
        <div class="demo-form-btn" @click="onSubmit('formInline')">продолжать</div>
      </div>
    </div>
    <!-- 底部协议 -->
    <div class="bom">
      <div class="bom_con">
        <div class="bom_con-text">Адрес:Казахстан, город Алматы, Бостандыкский район,улица Абиш Кекилбайулы, дом 34, офис</div>
        <div class="bom_minuIm">
          <div class="bom_con-num">Скачивай мобильное приложение через:</div>
          <div class="bom_minuIm">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt=""
              @click="googleFn()" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt="" @click="appstoreFn()" />
          </div>
        </div>
      </div>
      <div class="bom_mi">
        <div class="bom_mi-text">Понедельник-пятница 9:00 - 21:00 Суббота-воскресенье 11:00 - 21:00</div>
        <div class="bom_mi-tit">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М,
          от 12.09.2024 года, выдана Управлением региональных представителей в городе Алматы Агентства Республики
          Казахстан по регулированию и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    userInfo
  } from '@/api/info'
  export default {
    name: "contact",
    data() {
      return {
         //收入
        kinship_1: [
          'Родитель',
          'Брат',
          'Сестра',
          'Супруг',
          'Ребенок',
          'Друг',
          'Другое'
        ],
        // 教育水平
        kinship_2: [
          'Родитель',
          'Брат',
          'Сестра',
          'Супруг',
          'Ребенок',
          'Друг',
          'Другое'
        ],
        formInline: {
          relatives_1_name: '',
          kinship_1: '',
          relatives_1_phone: '',
          relatives_2_name: '',
          kinship_2: '',
          relatives_2_phone: ''
        },
        rules: {
          relatives_1_name: [
            { required: true, message: 'Пожалуйста, введите имя контакта!', trigger: 'blur' }
          ],
           kinship_1: [
             { required: true, message: 'Пожалуйста, выберите отношения контакта с вами!', trigger: 'change' }
           ],
           relatives_1_phone: [
             { required: true, message: 'Пожалуйста, введите контактный телефон!', trigger: 'blur' }
           ],
           relatives_2_name: [
             { required: true, message: 'Пожалуйста, введите свой полный адрес!', trigger: 'blur' }
           ],
            kinship_2: [
              { required: true, message: 'Пожалуйста, введите имя контакта!', trigger: 'change' }
            ],
            relatives_2_phone: [
              { required: true, message: 'Пожалуйста, введите контактный телефон!', trigger: 'blur' }
            ],
         },
         flage: false
      }
    },
    methods:{
      limitPhoneNum(e,val){
        if (e.toString().length > 10) {
            this.formInline[val] = this.formInline[val].toString().slice(0, 10)
        }
      },
      onSubmit(formName){
        let mobile = localStorage.getItem('phone')
        if(this.formInline.relatives_1_phone.length != 10 || this.formInline.relatives_2_phone.length != 10){
          this.$message.error({
            message: 'Пожалуйста, введите контактный телефон!'
          });
          return
        }
        if((this.formInline.relatives_1_phone == this.formInline.relatives_2_phone) || (this.formInline.relatives_1_name == this.formInline.relatives_2_name)){
          this.$message.error({
            message: 'Контактные телефоны не могут повторяться!'
          });
          return
        }
        if(this.formInline.relatives_1_phone == mobile || this.formInline.relatives_2_phone == mobile){
          this.$message.error({
            message: 'Запрещено вводить этот номер телефона!'
          });
          return
        }
        if(this.flage) return
        this.flage = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
              var parameter = {
                relatives_1_name: this.formInline.relatives_1_name,
                kinship_1: this.formInline.kinship_1 + 1,
                relatives_1_phone: '7' + this.formInline.relatives_1_phone,
                relatives_2_name: this.formInline.relatives_2_name,
                kinship_2: this.formInline.kinship_2 + 1,
                relatives_2_phone: '7' +  this.formInline.relatives_2_phone,
                relatives_3_name: "",
                kinship_3: "",
                relatives_3_phone: "",
                step: 12
              }
              userInfo(parameter).then(res => {
                if(res.data.status != 0){
                  this.flage = false
                  this.$message.error({
                    message: res.data.remark || 'Отправка не удалась'
                  });
                }else{
                  this.flage = false
                  this.$router.push('/underreview')
                }
              })
            } else {
              this.flage = false
              console.log('error submit!!');
              return false;
            }
        });
      },
      googleFn() {
        location.href = 'https://play.google.com/store/apps/details?id=express.credit.fast.tez.loan.money.cash.pay.bank.card'
      },
      privacyFn() {
        location.href = 'https://mfoeckz.com/privacy.html'
      },
      BasicRulesFn() {
        location.href = 'https://mfoeckz.com/BasicRules.pdf'
      },
      contractFn() {
        location.href = 'https://mfoeckz.com/contract.pdf'
      },
      appstoreFn() {
        location.href = 'https://apps.apple.com/kz/app/%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B9-%D0%B7%D0%B0%D0%B9%D0%BC/id6751275518'
      }
    },
  }
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    border: none;
    Outline: none;
  }

  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.27rem;
    height: 0.27rem;
    cursor: pointer;
  }
  .ut{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
  }
  .minu {
    border-top: 0.01rem solid #C0C0C0;
    padding-top: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.31rem;
  }
  .minu_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.17rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.13rem;
  }
  .from_title{
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .demo-form-inline{
     width: 2.8rem;
   }
   .el-select-dropdown__item{
     padding: 0 0.12rem;
   }
  /deep/ .el-form .el-form-item {
      margin-bottom: 0.1rem;
   }
  /deep/ .el-form-item__error {
    width: 10rem !important;
    color: #F56C6C;
    font-size: 12px;
    padding-top: 2px;
    margin-bottom: 12px !important;
  }
  .demo-form-btn{
    width: 2.81rem;
    height: 0.29rem;
    line-height: 0.29rem;
    text-align: center;
    background: #D4AF37;
    border-radius: 0.15rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  /* 底部 */
  .bom {
    background: #F9F9F9;
    padding: 0.52rem 1.88rem;
  }

  .bom_con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.31rem;
  }

  .bom_con-text {
    width: 2.76rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
  }

  .bom_minuIm {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_con-num {
    width: 1.1rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.15rem;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
  }
  .bom_mi{
    display: flex;
    flex-direction: row;
  }
  .bom_mi-text{
    width: 1.78rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.4rem;
  }
  .bom_mi-tit{
    width: 4rem;
    height: 0.38rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }

</style>



// WEBPACK FOOTER //
// src/components/contact.vue